import { InnerBox } from "@/components/elements/InnerBox";
import { Notification } from "@/components/commons/notification/Notification";
import { TopAlert } from "@/features/dashboard/components/TopAlert";
import { Stack } from "@mui/material";
import { FC } from "react";

export const DashboardPage: FC = () => {
  return (
    <Stack gap={4}>
      <TopAlert />
      <InnerBox title="お知らせ" variantTitle="head20Bold" showDivider={false} gap={3}>
        <Notification isHideContent isSingleLine isPreview />
      </InnerBox>
    </Stack>
  );
};
